import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  center: {
    color: 'black',
    width: '100%',
    textAlign: 'center',
  },
  dialogBody: {
    width: '460px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 4),
    },
    display: 'flex',
    flexFlow: 'wrap',
  },
  messageBody: {
    width: '100% !important',
    marginTop: '32px',
  },
  button: {
    width: '100%',
    maxWidth: '460px',
  },
  passwordResetButtons: {
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
      marginRight: theme.spacing(0),
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(0),
      marginRight: theme.spacing(3),
    },
  },
  passwordResetButtonsGrid: {
    [theme.breakpoints.down('md')]: {
      display: 'inline-table',
    },
    [theme.breakpoints.up('md')]: {
      display: 'inline-flex',
    },
  },
}));
